export default "assets/images/flags/fr-b797ba99.svg";